/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNthRoot } from '../../factoriesNumber.js';
export var nthRootDependencies = {
  typedDependencies,
  createNthRoot
};